<template>
	<PageArrows 
		v-bind:className="'patient'"
		v-bind:linkPrev="`/patient/${which}/${content[which].prevTab}`"
		v-bind:linkNext="`/patient/${which}/${content[which].nextTab}`"
		v-bind:linkNextInterim="content[which].nextTabInterim"
		v-bind:questionPopupDisplay="questionPopupDisplay"
		v-on:load-interim="loadInterim"
	></PageArrows>
	<ColumnLayout
		v-bind:which="which"
		v-bind:tabType="tabType"
		v-bind:content="content"
		v-bind:questionPopupDisplay="questionPopupDisplay"
	></ColumnLayout>
	<teleport to="body">
		<QuestionPopup
			v-if="content[which].InterimQA && questionPopupDisplay"
			v-bind:which="which"
			v-bind:tabType="tabType"
			v-bind:content="content"
			v-on:close-then="closeThen()"
		></QuestionPopup>
	</teleport>
</template>
<script>
import PageArrows from '@/components/PageArrows'
import ColumnLayout from '@/components/ColumnLayout'
import QuestionPopup from '@/components/QuestionPopup'
export default {
	components: {
		PageArrows,
		ColumnLayout,
		QuestionPopup
	},
	data() {
		return {
			which: this.$route.params.which,
			tabType: 'risk-assessment',
			questionPopupDisplay: false,
			content: {
				bishop: {
					prevTab: 'diagnosis/',
					nextTab: 'pre-initiation/',
					nextTabInterim: true,
					columnA: 370,
					columnB: 332,
					columnC: 212,
					columnChide: true,
					InterimQA: {
						type: 'radio',
						question: 'Based on these assessments, what is Mr. Bishop’s tumor burden?',
						choices: [
							'Mr. Bishop has a high tumor burden',
							'Mr. Bishop has a medium tumor burden',
							'Mr. Bishop has a low tumor burden'
						],
						answer: '1',
						answerSize: 957
					}
				}
			}
		}
	},
	methods: {
		loadInterim(){
			this.questionPopupDisplay = true
		},
		closeThen(){
			this.questionPopupDisplay = false
			this.content[this.which].columnChide = false
			this.content[this.which].nextTabInterim = false
		}
	}
}
</script>